export function getModal() {
  return this.getRoot()?.Modal
}

export function getModalData(key) {
  const data = this.getModal()?.data
  if (key) {
    return data?.[key]
  }
  return data
}

export async function openModal(key, val, opts = {}) {
  const el = this
  const root = el.getRoot()
  const Modal = root.Modal
  let FoundModal

  // if () {
  if (key && this.getCanvasScope()) this.getCanvasScope().modal = key

  const modalKey = key || val?.key || this.getWindow('modal')
  const content = Modal.routes[modalKey]
  if (content) {
    this.getRootState().activeModal = modalKey
    FoundModal = content
  } else {
    const modalParams = el.call('findModal')
    // if (val?.key) this.router(val?.key)
    if (!modalParams || opts.forcePreviewUpdate) return
    this.getRootState().activeModal =
      modalParams.beforeLastRoute || modalParams.lastRoute
    FoundModal = modalParams.FoundModal
  }

  if (FoundModal) {
    root.state.activeModal = modalKey
    if (root.Modal.content && !opts.forced) return
    root.Modal.setNodeStyles({
      opacity: '1',
      visibility: 'visible',
      pointerEvents: 'auto'
    })

    await root.Modal.removeContent()
    await root.Modal.set(
      {
        extends: FoundModal,
        state: val,
        animation: 'modalIn',
        animationFillMode: 'both',
        ...opts.animationProps
        // animationDelay: 'Z'
      },
      {
        ...opts,
        bySet: true
      }
    )
  }
}

export async function closeModal() {
  const el = this
  const Modal = el.getModal()

  delete this.getRootState().activeModal

  Modal?.setNodeStyles({
    opacity: '0',
    visibility: 'hidden',
    pointerEvents: 'none'
  })

  await Modal?.content?.update({
    animation: 'modalOut',
    animationDuration: '0',
    animationDelay: '0'
  })

  const t = setTimeout(async () => {
    await el.call('removeModal')
    clearTimeout(t)
  }, 350)
}

export async function removeModal() {
  const Modal = this.getModal()

  // if (location.pathname !== '/canvas') {
  //   const { index } = this.call('findModal')
  //   const path = window.location.pathname
  //   const routes = path.slice(1).split('/').slice(0, -index)
  //   const href = '/' + routes.join('/')

  //   this.router(
  //     href,
  //     this.getRoot(),
  //     {},
  //     {
  //       scrollToTop: false,
  //       updateStateOptions: {
  //         scrollToTop: false,
  //         forceRerender: true,
  //         onlyUpdate: 'Modal'
  //       }
  //     }
  //   )
  // }

  await Modal?.removeContent()
}
